import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { logger } from './logger';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const buildCustomUTMUrl = (
  originalUrl: string | null | undefined,
  params: {
    source?: string;
    medium?: string;
    campaign?: string;
    term?: string;
    content?: string;
  } = {}
): string | null => {
  if (!originalUrl || !originalUrl.trim()) {
    return null;
  }

  try {
    const url = new URL(originalUrl.trim());

    // Default values
    const utmParams = {
      utm_source: params.source || 'ceen',
      utm_medium: params.medium || 'event_directory',
      utm_campaign: params.campaign || 'promo_winter_2025',
      ...(params.term && { utm_term: params.term }),
      ...(params.content && { utm_content: params.content }),
    };

    Object.entries(utmParams).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });

    return url.toString();
  } catch (error) {
    logger.warn(
      'Invalid URL provided to buildCustomUTMUrl:',
      {
        originalUrl,
        urlType: typeof originalUrl,
        params,
      },
      error
    );
    return originalUrl;
  }
};
